import { UserTaskStatus, UserTaskType } from "@/enums/mateEnums";

export const getStatusBadgeClass = (status: UserTaskStatus) => {
  switch (status) {
    case UserTaskStatus.IN_PROGRESS:
      return "badge-outline badge-error";
    case UserTaskStatus.COMPLETED:
      return "badge-warning";
    case UserTaskStatus.CLAIMED:
      return "badge-success";
    default:
      return "badge-ghost";
  }
};

export const getTypeTagClass = (type: UserTaskType) => {
  switch (type) {
    // case UserTaskType.DAILY:
    //   return "badge-info";
    // case UserTaskType.WEEKLY:
    //   return "badge-warning";
    // case UserTaskType.ACTIVITY:
    //   return "badge-secondary";
    // case UserTaskType.MAINQUEST:
    //   return "badge-accent";
    // case UserTaskType.SIDEQUEST:
    //   return "badge-ghost";
    default:
      return "badge-ghost";
  }
};
